import goal3 from "../../Assest/HomeBack/GOOD HEALTH & WELL BEING.png";
import goal4 from "../../Assest/HomeBack/QUALITY EDUCATION.png";
import goal5 from "../../Assest/HomeBack/GENDER EQUALITY.png";
import goal6 from "../../Assest/HomeBack/Water.jpeg";
import goal8 from "../../Assest/HomeBack/DECENT WORK & ECONOMIC GROWTH.jpg";
import goal10 from "../../Assest/HomeBack/REDUCED INEQUALITIES.jpg";
import goal11 from "../../Assest/HomeBack/Sustaininble communities.png";
import goal13 from "../../Assest/HomeBack/Climate.png";
import goal17 from "../../Assest/HomeBack/PARTNERSHIPS FOR THE GOALS.png";
import React, { useState, useEffect } from 'react';
import './homepage.css';
import Button from 'react-bootstrap/Button';
import {
  FaWater,
  FaToolbox,
  FaFemale,
  FaGraduationCap,
  FaUsers,
  FaLeaf,
  FaToilet,
  FaHeartbeat,
  
  FaUsersCog,
  FaTint,
  FaTree,
  FaSeedling
} from "react-icons/fa";

import {
  FaIndustry,
  FaMapLocationDot,
  FaPeopleGroup,
  FaCalendarDays,
  FaCow,
  FaBoreHole
} from "react-icons/fa6";

import Footer from "../footer/Footer";
const CountUp = ({ endValue }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 6000; // slower animation
    const stepTime = 25;
    const increment = endValue / (duration / stepTime);

    const timer = setInterval(() => {
      start += increment;

      if (start >= endValue) {
        start = endValue;
        clearInterval(timer);
      }

      setCount(Math.floor(start));
    }, stepTime);

    return () => clearInterval(timer);
  }, [endValue]);

  return (
    <h1>
      {count.toLocaleString()}
      +
    </h1>
  );
};

const domainData = [
  {
    id: 1,
    title: "Water",
    icon: <FaWater />,
    color: "#1E88E5",
    link: "/projects"
  },
  {
    id: 2,
    title: "Livelihood",
    icon: <FaToolbox />,
    color: "#D97706",
    link: "/projects"
  },
  {
    id: 3,
    title: "Women Empowerment",
    icon: <FaFemale />,
    color: "#D62839",
    link: "/projects"
  },
  {
    id: 4,
    title: "Education",
    icon: <FaGraduationCap />,
    color: "#6A5ACD",
    link: "/projects"
  },
  {
    id: 5,
    title: "Adult Literacy",
    icon: <FaUsers />,
    color: "#4F7DF3",
    link: "/projects"
  },
  {
    id: 6,
    title: "Environment",
    icon: <FaLeaf />,
    color: "#2E7D32",
    link: "/projects"
  },
  {
    id: 7,
    title: "Youth Skilling",
    icon: <FaUsersCog />,
    color: "#F4B400",
    link: "/projects"
  },
  {
    id: 8,
    title: "Health & Sanitation",
    icon: <FaToilet />,
    color: "#EC407A",
    link: "/projects"
  }
];
const sdgData = [
  { id: 3, image: goal3 },
  { id: 4, image: goal4 },
  { id: 5, image: goal5 },
  { id: 6, image: goal6 },
  { id: 8, image: goal8 },
  { id: 10, image: goal10 },
  { id: 11, image: goal11 },
  { id: 13, image: goal13 },
  { id: 17, image: goal17 },
];
const fiveJData = [
  {
    title: "JAL",
    subtitle: "Water",
    icon: <FaTint />,
    color: "#1E88E5"
  },
  {
    title: "JUNGLE",
    subtitle: "Nature",
    icon: <FaTree />,
    color: "#2E7D32"
  },
  {
    title: "JAMEEN",
    subtitle: "Land",
    icon: <FaSeedling />,
    color: "#C17A3A"
  },
  {
    title: "JANAVAR",
    subtitle: "Livelihood",
    icon: <FaCow />,
    color: "#6A5ACD"
  },
  {
    title: "JANTA",
    subtitle: "People",
    icon: <FaUsers />,
    color: "#D62839"
  }
];


const HomePage = () => {
  const [glowId, setGlowId] = useState(null);

  const handleClick = (id) => {
    setGlowId(id);
    setTimeout(() => setGlowId(null), 1000);
  };

const impactData = [
  {
    id: 1,
    icon: <FaHeartbeat size={22} />,
    value: 100000,
    label: "Lives Transformed"
  },
  {
    id: 2,
    icon: <FaIndustry size={22} />,
    value: 40,
    label: "Borewells"
  },
  {
    id: 3,
    icon: <FaBoreHole size={22} />,
    value: 5,
    label: "Open Wells"
  },
  {
    id: 4,
    icon: <FaMapLocationDot size={22} />,
    value: 50,
    label: "Villages"
  },
  {
    id: 5,
    icon: <FaPeopleGroup size={22} />,
    value: 50,
    label: "Self Help Groups"
  },
  {
    id: 6,
    icon: <FaFemale size={22} />,
    value: 1200,
    label: "Women Empowered"
  },
  {
    id: 7,
    icon: <FaGraduationCap size={22} />,
    value: 6000,
    label: "Students Educated"
  },
  {
    id: 8,
    icon: <FaCalendarDays size={22} />,
    value: 25,
    label: "Years of Service"
  }
];
  return (
    <div style={{ fontFamily: 'Poppins, sans-serif' }}>
      <section className="homepage-hero-section">
        <div className="homepage-hero-content">
          <h1>Caring for Creation</h1>

          <p>
      Because every person, every community, and every part of nature is a precious part of creation worthy of care.
    </p>
          <div className="hero-cta-group">
            <Button variant="primary" href="#homepage-work-section">Our Programs</Button>
<Button
  as="a"
  variant="outline-light"
  href="https://docs.google.com/forms/d/e/1FAIpQLSchtRgHB_XmFj3VqO-6NTaQzKsYjp0W_6Se-6Rc9Ep1I14lyQ/viewform"
  target="_blank"
  rel="noopener noreferrer"
>
  Get Involved
</Button>          </div>
        </div>
      </section>

      <section className="homepage-about-section">
        <div className="homepage-container">


<h2>What is HDSI?</h2>

<p>
  Human Development Society of India (HDSI) is a non-profit organization committed to building a future where people, communities, and nature thrive together. Since 2002, we have been driving sustainable development across rural, tribal, and underserved urban regions of India.
</p>
        </div>
      </section>

      {/* ===================== 5J FRAMEWORK ===================== */}

<section className="fivej-section">
  <div className="fivej-bg-shape shape-left"></div>
  <div className="fivej-bg-shape shape-right"></div>

  <div className="homepage-container">

    <div className="fivej-heading">
      <span className="fivej-eyebrow">OUR APPROACH</span>

      <h2>
        THE <span className="fivej-highlight">5J</span> FRAMEWORK
      </h2>

      <p>
        Five interconnected pillars guiding sustainable,
        community-led development.
      </p>
    </div>

    <div className="fivej-chain">
      {fiveJData.map((item, index) => (
        <div className="fivej-oval-wrapper" key={index}>

          <div
            className="fivej-oval"
            style={{
              borderColor: item.color
            }}
          >
            <div
              className="fivej-icon-bg"
              style={{
                background: `${item.color}15`,
                color: item.color
              }}
            >
              {item.icon}
            </div>

            <h3 style={{ color: item.color }}>
              {item.title}
            </h3>

            <p>{item.subtitle}</p>
          </div>

          {index !== fiveJData.length - 1 && (
           <div
  className="fivej-connector"
  style={{
    background: `linear-gradient(90deg, transparent, ${item.color}, transparent)`
  }}
/>
          )}

        </div>
      ))}
    </div>

  </div>
</section>

{/* ===================== END 5J ===================== */}
      <section id="homepage-work-section" className="homepage-work-section">
        <div className="homepage-container">
          <span className="section-eyebrow">Our Programs</span>
          <h2>Areas of Work</h2>
          <div className="homepage-work-grid">

  {domainData.map((domain) => (

    <a
      key={domain.id}
      href={domain.link}
      className="program-card"
      style={{ "--accent": domain.color }}
    >

      <div className="program-icon">
        {domain.icon}
      </div>

      <h4>{domain.title}</h4>

      <span className="program-arrow">
        →
      </span>

    </a>

  ))}

</div>
        </div>
      </section>

      <section className="sdg-section">

  <span className="sdg-subtitle">
    OUR GLOBAL COMMITMENT
  </span>

  <h2 className="sdg-title">
    Supporting the UN Sustainable Development Goals
  </h2>

  <div className="sdg-marquee">

    <div className="sdg-track">

      {[...sdgData, ...sdgData].map((goal, index) => (

        <div className="sdg-card" key={index}>

          <img
            src={goal.image}
            alt={`SDG Goal ${goal.id}`}
          />

        </div>

      ))}

    </div>

  </div>

</section>

<section
  id="homepage-impact-section"
  className="homepage-impact-section"
>
  <div className="homepage-container">

    <span className="section-eyebrow">
      OUR IMPACT
    </span>

    <h2 className="impact-header">
      Measuring Change Through Action
    </h2>

    <p className="impact-subtitle">
      More than two decades of community-led development across
      education, water, livelihoods, women empowerment and environmental
      sustainability.
    </p>

    <div className="homepage-impact-grid">
      {impactData.map((item) => (
        <div
          key={item.id}
          className={`homepage-impact-item ${
            glowId === item.id ? "glow-effect" : ""
          }`}
          onClick={() => handleClick(item.id)}
        >
          <div className="impact-icon">
            {item.icon}
          </div>

          <CountUp endValue={item.value} />

          <h5>{item.label}</h5>
        </div>
      ))}
    </div>

  </div>
</section>

<Footer />
</div>
);
};

export default HomePage;
